import gql from 'graphql-tag'

export const GET_CURRENCY_PAGINATED_QUERY = gql`
  query (
    $skip: Int!,
    $take: Int!,
    $orderBy: [OrderByInput!]
  ) {
    getCurrencyPaginated (
      data: {
        orderBy: $orderBy
        pagination: {
          skip: $skip
          take: $take
        }
      }
    ) {
      hasMore
      total
      items {
        title
        symbol
        main
        left
        deletedAt
      }
    }
  }
`

export const GET_CURRENCY_QUERY = gql`
  query (
    $title: String!,
  ) {
    getCurrency (
      data: {
        title: $title
      }
    ) {
      title
      symbol
      main
      left
    }
  }
`
